export interface IParametroSistema {
    id: number;
    descricao: string;
    nome: string;
    valor: string;
    cpfultimaAlteracao: string,
    dataUltimaAlteracao: string
    categoria: ICategoriaParametro
}

export interface ICategoriaParametro {
    codigo: number;
    descricao: string;
}

export interface IValidacaoParametro {
    nome: string;
    valor: string;
}

export const parametroDefault = {
    descricao: '',
    nome: '',
    valor: ''
} as IParametroSistema;

/**
 * Parâmetro de sistema com as siglas das unidades liberadas para o escaninho de pauta,
 * separadas por vírgula ou ponto e vírgula. Ex.: 'GAB1DES, GAB2DES'.
 */
export const PARAMETRO_UNIDADES_ESCANINHO_PAUTA = 'GabsEscaninhoPauta';

/** Valores que, no parâmetro acima, liberam o escaninho de pauta para todas as unidades. */
export const VALORES_TODAS_UNIDADES = ['TODAS', 'TODOS', '*'];

export const validacaoDefault = {} as IValidacaoParametro;
